import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from './HeroSection';
import phone from '../images/smartphone.png';
import arrow from '../images/long-arrow.svg';
import imac from '../images/imac.png';
import laptop from '../images/laptop.png';
import sass from '../images/sass.png';
import npm from '../images/npm.png';
import node from '../images/nodejs.png';
import java from '../images/java.png';
import html from '../images/html.png';
import css from '../images/css.png';
import javascript from '../images/javascript.png';
import raspberry from '../images/raspberry-pi.png';
import react from '../images/react.png';
import python from '../images/python.png';
import docker from '../images/docker.png';
import aws from '../images/aws.png';
import mysql from '../images/mysql.png';
import bootstrap from '../images/bootstrap.png';
import github from '../images/github.png';
import postgre from '../images/postgre.png';
import ReactTypingEffect from 'react-typing-effect';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";
import './WorkPreviews.css';

function WorkPreviews() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://api.jsonbin.io/v3/b/65c7cefddc74654018a30540');
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const jsonData = await response.json();
        setData(jsonData.record); // Assuming the JSON data is stored in a "record" field
      } catch (error) {
        console.error('Error fetching data: ', error);
        // Optionally, handle error state here
      }
    };

    fetchData();

    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  return (
    <>
      {/* Hero Section */}
      <div className='mt-20'>
        <HeroSection />
      </div>
      {/* Work Previews */}
      <div id='portfolio' className="work-hero mt-12">
        <div className='work-hero-div1'>
          <h2 className="work-hero-title">
            I translate Code ⎁ into Intuitive Software Experiences <span className='emoji-work-hero'> ˆ⌣ˆ</span>
          </h2>
          <p className="work-hero-desc mb-8">
            Through my projects in web development, mobile applications, and design, I blend aesthetics with functionality to create impactful digital experiences. My aspiration is to leverage these skills to contribute towards a better world, where technology enhances lives and fosters positive change.
          </p>
        </div>
        <div className='work-hero-div2'>
          <div className="laptops-image">
            <img className='work-icon' src="https://iili.io/dnsaVGs.png" alt="Laptop Icon" />
          </div>
        </div>
      </div>
      <ScrollAnimation animateIn="fadeIn" animateOnce>
        {/* Section for logos */}
        <div className="logos mx-10">
          <div className="logo_items mt-8">
            <img src={html} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={css} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={javascript} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={bootstrap} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={sass} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={node} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={java} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={react} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={html} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={css} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={javascript} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={bootstrap} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={sass} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={node} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={java} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={react} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={html} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={css} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={javascript} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={bootstrap} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={sass} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={node} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={java} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={react} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={html} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={css} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={javascript} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={bootstrap} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={sass} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={node} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={java} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={react} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={html} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={css} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={javascript} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={bootstrap} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={sass} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={node} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={java} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={react} className="logo w-8 md:w-20" alt="HTML Logo" />
            <img src={html} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={css} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={javascript} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={bootstrap} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={sass} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={node} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={java} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={react} className="logo w-12 md:w-20" alt="HTML Logo" />
          </div>
        </div>
        <div className="logos mb-20 mx-10">
          <div className="logo_items2 mt-4">
            <img src={python} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={docker} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={aws} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={mysql} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={github} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={postgre} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={raspberry} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={npm} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={python} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={docker} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={aws} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={mysql} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={github} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={postgre} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={raspberry} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={npm} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={python} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={docker} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={aws} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={mysql} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={github} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={postgre} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={raspberry} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={npm} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={python} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={docker} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={aws} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={mysql} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={github} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={postgre} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={raspberry} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={npm} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={python} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={docker} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={aws} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={mysql} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={github} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={postgre} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={raspberry} className="logo w-12 md:w-20" alt="HTML Logo" />
            <img src={npm} className="logo w-12 md:w-20" alt="HTML Logo" />
          </div>
        </div>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" animateOnce>
        <div className="mywork">
          <div className="cursor-pointer paddingClass grid grid-cols-1 md:grid-cols-5 mx-auto gap-2 max-w-90vw min-h-0 work-mob">
            {data.map((work, index) => {
              let colSpanClass = 'col-span-1 md:col-span-5';
              switch (index % 4) {
                case 1:
                  colSpanClass = 'col-span-1 md:col-start-1 md:col-span-3';
                  break;
                case 2:
                  colSpanClass = 'col-span-1 md:col-start-4 md:col-span-2';
                  break;
                case 3:
                  colSpanClass = 'col-span-1 md:col-start-1 md:col-span-2';
                  break;
                case 0:
                  if (index !== 0) {
                    colSpanClass = 'col-span-1 md:col-start-3 md:col-span-3';
                  }
                  break;
                default:
                  break;
              }
              return (
                <div
                  key={index}
                  className={`p-2 ${colSpanClass} relative group cursor-pointer`}
                  onClick={() => navigate(`/work/${work.slug}`)}
                >
                  <img
                    src={work.heroImage}
                    alt={work.title}
                    className="cursor-pointer element-work w-full transition-all ease-in-out object-cover"
                    style={{ height: '60vh' }}
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="cursor-pointer absolute inset-0 text-center opacity-0 group-hover:opacity-100 flex items-center justify-center m-0 transition-opacity duration-300">
                    <div className="cursor-pointer bg-white bg-opacity-80 backdrop-blur-sm rounded-full p-8 m-8">
                      <p className="cursor-pointer text-black font-regular">
                        <h2 className="description-cards">{work.title} • {work.type}</h2>
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className='agency-introduction'>
            <div>
              <h2 className="arrow"><img src={arrow} alt="Arrow Icon" /></h2>
            </div>
            <div>
              <a href="/about" rel="noopener noreferrer">
                <div className='agency-button'>
                  <h2 className='discover font-normal'>Learn More About Me</h2>
                  <h2 className='luma'>* About *</h2>
                </div>
              </a>
            </div>
          </div>
        </div>
      </ScrollAnimation>
          </>
      );


    }
    
    export default WorkPreviews;
